

























import {Component, Vue, Prop} from 'vue-property-decorator';
import { RawLocation } from 'vue-router';

@Component<InNameToolBox>({
    name: 'InNameToolBox',
})
export default class InNameToolBox extends Vue {
    @Prop({ type: Function }) private duplicate!: (row: any) => any;
    @Prop({ required: true, type: Array }) private whichTools!: string[];

    private clickHandler(isCtrlPressed: boolean) {
        this.$emit('editClick', isCtrlPressed);
    }
    private historyHandler(isCtrlPressed: boolean) {
        this.$emit('historyClick', isCtrlPressed);
    }
}
